import { render, staticRenderFns } from "./CredenciamentoBuscaTabela.vue?vue&type=template&id=6ed7767e&scoped=true"
import script from "./CredenciamentoBuscaTabela.vue?vue&type=script&lang=js"
export * from "./CredenciamentoBuscaTabela.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoBuscaTabela.vue?vue&type=style&index=0&id=6ed7767e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7767e",
  null
  
)

export default component.exports